import InputField from "../../components/shared-components/Input"
import SearchAirportsDropDown from "../../components/shared-components/searchAirportsDropDown"

export function formInputs(
  key,
  airports,
  value,
  handleChange,
  placeholder,
  setFieldValue,
  handleBlur,
  errors,
  touched
) {
  if (key === "departure" || key === "destination") {
    return (
      <SearchAirportsDropDown
        sortedAirports={airports}
        fieldName={key}
        value={value}
        onChange={handleChange}
        placeholder={placeholder(key)}
        setFieldValue={setFieldValue}
      />
    )
  } else {
    return (
      <InputField
        placeholder={placeholder(key)}
        type={
          key === "shipment_date"
            ? "date"
            : key === "weight"
            ? "number"
            : "text"
        }
        className={"bg-white !px-0"}
        required
        value={value}
        name={key}
        onBlur={handleBlur}
        onChange={handleChange}
        errors={errors[key]}
        touched={touched[key]}
        key={key}
      />
    )
  }
}
